import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SecondaryButton',
  props: {
  vIcon: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  color: {
    type: String,
    default: "none",
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_DARK_GRAY,
    }),
    required: false,
  },
},
  setup(__props) {

const props = __props



const isSecondaryGray = computed(() => {
  if (props.theme.borderColor) return false
  else return props.theme.primaryColor === THEMES.PERALTA_DARK_GRAY
})

return { __sfc: true,props, isSecondaryGray, Icon }
}

})